// Decode symbols like amp;
const decodeString = (string) => {
  const txt = document.createElement('textarea');
  txt.innerHTML = string;
  return txt.value;
};

export default decodeString;
